
import {Checkbox, FormGroup, Paper, TextField, Typography, FormControlLabel, Button, FormControl, Select, InputLabel, MenuItem} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import { fetchCustomers, addCustomer, fetchLeadbyId, fetchEmployees, fetchCustomerbyNumber, fetchtodaycust, updateLeaddata } from "../api/customerapi";
import GetRole from "./user";
import Loading from "./loading";
import { useAppData } from "./appDataContext.js";


const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      input: {
        "&:invalid": {
          border: "red solid 2px"
        }
      },
  }));

const Custdataentry = () => {

    const classes = useStyles();
    const preURL=document.referrer;
    const urlarray=preURL.split("/");
    const leadid=urlarray[urlarray.length-1];
    const leadpage=urlarray[urlarray.length-2];
    const [working, setworking]=useState(false);
    const [leadData, setleadData]=useState(false);
    const [custData, setcustData] =useState({
        cust_name: "",
        primary_mobile_number: undefined,
        chat_mobile_number: undefined,
        lead_id:0,
        secondary_mobile_numbers: "",
        only_chat: false,
        super_user: false,
        marketing_message: true,
        cust_ref: "",
        cust_notes: "",
        cust_channel: "",
        primary_email_id: "",
        secondary_email_ids: "",
        cust_city: "",
        cust_state: "",
        cust_model: "B2C",
        cust_createdBy: "",
        cust_trips:[]
    });
    const [cData, setcData]=useState([]);
    const [emp, setemp]=useState([])
    const [followupData, setfollowupData] =useState({
        notes:"",
        status:"Open",
        roc:""
    });
  const { appData, loading } = useAppData();
    var { cuser, role } = GetRole();
    const getCustomers = async () => {
      try{
        const data = await fetchCustomers();
        //const custdatalistfromdb= data.data
        setcData(data.data)
      }catch(err){
        console.log(err)
      }
        //console.log(cData)
    }
    const getLead = async (id) => {
      try{
        const data = await fetchLeadbyId(id);
        setleadData(data.data)
        setcustData({
            primary_mobile_number: data.data.mobile_number,
            chat_mobile_number: data.data.mobile_number,
            cust_name: data.data.lead_name,
            primary_email_id:data.data.email_id,
            lead_id:data.data.lead_id,
            cust_model:"B2C"
        })
        setfollowupData({
          owner:data.data.lead_owner,
          notes:"",
          status:"Open",
          roc:""
        })
      }catch(err){
        console.log(err)
      }
    }
//console.log(cData)
    const getEmployees = async () => {
      try{
        const data = await fetchEmployees();
        //const custdatalistfromdb= data.data
    
        const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "SME");
        const empshortname = empsplist.map((emp) => emp.short_name);
        let sortedemp = empshortname.sort()
        setemp(sortedemp);
        //setemp(empshortname);
      }catch(err){
        console.log(err)
      }
      };

    useEffect(() => {
        //getCustomers()
        getEmployees()
        //console.log(leadid)
        if(!isNaN(parseInt(leadid)) && leadpage=="lead"){
            //console.log("working")
            getLead(parseInt(leadid))
        }
        
    }, [])
    //console.log(new Date().toLocaleString("en-IN"));
    //const updatedName= useSelector((state)=> currentID ? (state.reducerNames.find((p) => p._id ===currentID)) : null);

    const handleSubmit =async (e) => {
      try{
                e.preventDefault();
                setworking(true)
        const data= await fetchCustomerbyNumber(custData.primary_mobile_number);
        //console.log(data.data)
        if(data.data.length>0){
            alert ("Customer already exists with this mobile number. Cust id is: "+data.data[0].cust_id)
            const newlead={...leadData, work_complete:true, work_complete_date:new Date()}
            const updateleadResponse = await updateLeaddata(leadData._id, newlead);
            alert("Lead updated: "+leadData.lead_id)
            window.location = ("/custdataentry/"+data.data[0].cust_id);
        }else{
        const data3 = await fetchtodaycust();
        const temp=data3.data.filter(cust=>cust.follow_up.owner==cuser)
        if(temp.length>14){
          alert ("Customer create limit exhausted. Try again tomorrow")
        }else{
        const newcustData={...custData, follow_up:followupData, createdAt: new Date()}
        //console.log(newcustData);
        const addcustResponse= await addCustomer(newcustData);
        const userid=custData.primary_mobile_number+"@jeto.com"
        
        if(addcustResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("New customer added with cust id "+addcustResponse.data.cust_id);
            const newlead={...leadData, work_complete:true, work_complete_date:new Date()}
            const updateleadResponse = await updateLeaddata(leadData._id, newlead);
             if(updateleadResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
              alert("Lead updated: "+leadData.lead_id)
             }
            window.location = ("/custdataentry/"+addcustResponse.data.cust_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
      }
    }
  }catch(err){
    console.log(err)
  }
    }

  if (working) {
    return <Loading message={`Saving data...`} />;
  }

  
    return (  
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add New Customer</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Name"  value={custData.cust_name} className={classes.textField} onChange={(e)=> setcustData({...custData, cust_name: e.target.value})}/>
                <TextField variant="standard" required  label="Primary Mobile Number (number)"  inputProps={{className: classes.input, pattern:"[0-9]{8,14}"}} InputLabelProps={{ shrink: true }} value={custData.primary_mobile_number} className={classes.textField} onChange={(e)=> setcustData({...custData, primary_mobile_number: e.target.value})}/>
                <TextField variant="standard"  label="Chat Number (number)"  InputLabelProps={{ shrink: true }} inputProps={{className: classes.input, pattern:"[0-9]{8,14}"}} value={custData.chat_mobile_number} className={classes.textField} onChange={(e)=> setcustData({...custData, chat_mobile_number: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Primary Email Id"  value={custData.primary_email_id} className={classes.textField} onChange={(e)=> setcustData({...custData, primary_email_id: e.target.value})}/>
                <TextField variant="standard"  label="Secondary Email Ids"  value={custData.secondary_email_ids} className={classes.textField} onChange={(e)=> setcustData({...custData, secondary_email_ids: e.target.value})}/>
                <TextField variant="standard" label="Secondary Mobile Numbers"   value={custData.secondary_mobile_numbers} className={classes.textField} onChange={(e)=> setcustData({...custData, secondary_mobile_numbers: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={custData.only_chat} label="Only Chat" onChange={(e)=> setcustData({...custData, only_chat: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary" defaultChecked />}  value={custData.marketing_message} label="Send Marketing messages"  onChange={(e)=> setcustData({...custData, marketing_message: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={custData.super_user} label="Super User" onChange={(e)=> setcustData({...custData, super_user: e.target.checked})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="City"  value={custData.cust_city} className={classes.textField} onChange={(e)=> setcustData({...custData, cust_city: e.target.value})}/>
                <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 64,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="State">State</InputLabel>
                <Select
                  classname={classes.textField}
                  
                  labelId="State"
                  value={custData.cust_state ? custData.cust_state : ""}
                  onChange={(e) =>
                    setcustData({ ...custData, cust_state: e.target.value })
                  }
                >
                  <MenuItem value={"Andaman & Nicober Islands"}>
                    Andaman & Nicober Islands
                  </MenuItem>
                  <MenuItem value={"New Delhi"}>New Delhi</MenuItem>
                  <MenuItem value={"Karnataka"}>Karnataka</MenuItem>
                  <MenuItem value={"Telengana"}>Telengana</MenuItem>
                  <MenuItem value={"Andhra Pradesh"}>Andhra Pradesh</MenuItem>
                  <MenuItem value={"Manipur"}>Manipur</MenuItem>
                  <MenuItem value={"Maharashtra"}>Maharashtra</MenuItem>
                  <MenuItem value={"Goa"}>Goa</MenuItem>
                  <MenuItem value={"Odisha"}>Odisha</MenuItem>
                  <MenuItem value={"West Bengal"}>West Bengal</MenuItem>
                  <MenuItem value={"Gujarat"}>Gujarat</MenuItem>
                  <MenuItem value={"Assam"}>Assam</MenuItem>
                  <MenuItem value={"Haryana"}>Haryana</MenuItem>
                  <MenuItem value={"Punjab"}>Punjab</MenuItem>
                  <MenuItem value={"Chandigarh"}>Chandigarh</MenuItem>
                  <MenuItem value={"Himachal Pradesh"}>
                    Himachal Pradesh
                  </MenuItem>
                  <MenuItem value={"Uttar Pradesh"}>Uttar Pradesh</MenuItem>
                  <MenuItem value={"Sikkim"}>Sikkim</MenuItem>
                  <MenuItem value={"Rajasthan"}>Rajasthan</MenuItem>
                  <MenuItem value={"Jammu & Kashmir"}>Jammu & Kashmir</MenuItem>
                  <MenuItem value={"Madhya Pradesh"}>Madhya Pradesh</MenuItem>
                  <MenuItem value={"Chattisgarh"}>Chattisgarh</MenuItem>
                  <MenuItem value={"Bihar"}>Bihar</MenuItem>
                  <MenuItem value={"Jharkhand"}>Jharkhand</MenuItem>
                  <MenuItem value={"Nagaland"}>Nagaland</MenuItem>
                  <MenuItem value={"Tripura"}>Tripura</MenuItem>
                  <MenuItem value={"Mizoram"}>Mizoram</MenuItem>
                  <MenuItem value={"Arunachal Pradesh"}>
                    Arunachal Pradesh
                  </MenuItem>
                  <MenuItem value={"Tamil Nadu"}>Tamil Nadu</MenuItem>
                  <MenuItem value={"Kerala"}>Kerala</MenuItem>
                  <MenuItem value={"Ladakh"}>Ladakh</MenuItem>
                </Select>
              </FormControl>
                {/* <TextField variant="standard"  label="State"  value={custData.cust_state} className={classes.textField} onChange={(e)=> setcustData({...custData, cust_state: e.target.value})}/> */}
                <TextField variant="standard"  label="Referred customer ids"   value={custData.cust_ref} className={classes.textField} onChange={(e)=> setcustData({...custData, cust_ref: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  type="date" label="Date of birth"   value={custData.cust_dob} className={classes.textField} defaultValue="1990-01-01" onChange={(e)=> setcustData({...custData, cust_dob: e.target.value})}/>
                <TextField variant="outlined"  type="date" label="Anniversary"  value={custData.cust_anniversary} className={classes.textField} defaultValue="2021-01-01" onChange={(e)=> setcustData({...custData, cust_anniversary: e.target.value})}/>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 24, marginLeft: 5}}>
            <InputLabel id="model">Customer Model </InputLabel>
                <Select required className={classes.textField} labelId="model" value={custData.cust_model} onChange={(e)=> setcustData({...custData, cust_model: e.target.value})}>
                    <MenuItem value={"B2C"}>B2C</MenuItem>
                    <MenuItem value={"B2B"}>B2B</MenuItem>
                  
                
                </Select>
                </FormControl>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Notes"  value={custData.cust_notes} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> setcustData({...custData, cust_notes: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            {role?(<div>
              {role=="Sales"?(
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Followup Status</InputLabel>
                <Select className={classes.textField} labelId="status" value={followupData.status} onChange={(e)=> setfollowupData({...followupData, status: e.target.value})}>
                    <MenuItem value={"Open"}>Open</MenuItem>
                     
                
                </Select>
                </FormControl>
              ):(
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Followup Status</InputLabel>
                <Select className={classes.textField} labelId="status" value={followupData.status} onChange={(e)=> setfollowupData({...followupData, status: e.target.value})}>
                    <MenuItem value={"Open"}>Open</MenuItem>
                    <MenuItem value={"Closed"}>Closed</MenuItem>  
                
                </Select>
                </FormControl>
              )}
            </div>):("")}
            
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 24, marginLeft: 5}}>
            <InputLabel id="owner">Owner *</InputLabel>
                <Select className={classes.textField} labelId="Owner" required value={followupData.owner} disabled={"owner" in followupData && followupData.owner =="" && role=="Sales"?1:0} onChange={(e)=> setfollowupData({...followupData, owner: e.target.value})}>
                <MenuItem value={"Amit"}>Amit</MenuItem>
                <MenuItem value={"Abhishek"}>Abhishek</MenuItem>
                <MenuItem value={"NitinK"}>NitinK</MenuItem>
                <MenuItem value={"Asgar"}>Asgar</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
                    
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 24, marginLeft: 5}}>
            <InputLabel id="roc">Cancellation Reason </InputLabel>
                <Select  className={classes.textField} labelId="roc" value={followupData.roc} onChange={(e)=> setfollowupData({...followupData, roc: e.target.value})}>
                    <MenuItem value={"No response"}>No response</MenuItem>
                    <MenuItem value={"Destination not served"}>Destination not served</MenuItem>
                    <MenuItem value={"Product not served"}>Product not served</MenuItem>
                     <MenuItem value={"Already Booked"}>Already Booked</MenuItem>
                    <MenuItem value={"Denied placing lead"}>Denied placing lead</MenuItem>
                    <MenuItem value={"Plan cancelled"}>Plan cancelled</MenuItem>
                    <MenuItem value={"Budget mismatch"}>Budget mismatch</MenuItem>
                    <MenuItem value={"Misunderstood ad"}>Misunderstood ad</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                
                </Select>
                </FormControl>

                      
                <TextField variant="standard"  type="date" label="Followup Date"  className={classes.textField} InputLabelProps={{ shrink: true }} onChange={(e)=> setfollowupData({...followupData, date: e.target.value})}/>
                <TextField variant="standard"  type="time" label="Followup Time"  className={classes.textField} InputLabelProps={{ shrink: true }} onChange={(e)=> setfollowupData({...followupData, time: e.target.value})} />
                <TextField variant="standard"  label="Followup Notes"  value={followupData.notes} className={classes.textField} fullwidth onChange={(e)=> setfollowupData({...followupData, notes: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                <Button href="/searchcust" variant="contained" color="primary" className={classes.button}>Search Customer</Button>
            </FormGroup>
              
            </form>
        </Paper>
    );
}
 
export default Custdataentry;